import _ from 'lodash'
import { Experiments, PlatformEnvData, SessionServiceAPI } from '@wix/thunderbolt-symbols'
import { platformBiLoggerFactory } from '../../bi/biLoggerFactory'
import type { AppEssentials } from '@wix/fe-essentials-viewer-platform'

export const reportTraceFactory = ({
	biData,
	experiments,
	appDefinitionId,
	sessionService,
	appEssentials,
}: {
	biData: PlatformEnvData['bi']
	experiments: Experiments
	appDefinitionId: string
	sessionService: SessionServiceAPI
	appEssentials: AppEssentials
}) => {
	if (!experiments.sv_reportTrace) {
		return _.noop
	}

	/**
	 * Trace event logger.
	 *
	 * Please don't add any additional fields unless they are defined in the BI schema
	 * https://bo.wix.com/bi-catalog-webapp/#/sources/72/events/100?artifactId=trace.artifact.id
	 */
	const logger = platformBiLoggerFactory({ sessionService, factory: appEssentials.biLoggerFactory })
		.createBaseBiLoggerFactory(biData)
		.updateDefaults({
			appName: appDefinitionId,
			src: 72,
			evid: 100,
		})
		.logger({ endpoint: 'trace' })

	return ({ actionName = 'noop', tracePosition = 'none', actionDurationMs = 0, message = '' } = {}) =>
		logger.log({
			timestampMs: Date.now(),
			timeFromStartMs: Date.now() - _.get(biData, 'ssrRequestTimestamp', biData.initialTimestamp),
			actionName,
			message,
			actionDurationMs,
			tracePosition,
		})
}
